var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.labelIconPosition')
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.optionModel.labelIconPosition),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "labelIconPosition", $$v)
      },
      expression: "optionModel.labelIconPosition"
    }
  }, _vm._l((_vm.labelIconPosition), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18f7d444","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/labelIconPosition-editor.vue
// module id = null
// module chunks = 